import { IStepperStepProps } from "./types";
import { useStepper } from "./context";
import { Button } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export function StepperStep({ disabled, body, hideOptions = false }: IStepperStepProps) {
  const { handleNextStep, handlePrevStep, handleSave, isFirstStep, isLastStep } = useStepper();

  return (
    <>
      <div>{body}</div>
      {!hideOptions && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "50px",
          }}
        >
          <Button
            variant="outlined"
            style={{
              paddingTop: "0.25rem",
              paddingBottom: "0.25rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: "0.375rem",
              height: "2.5rem",
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
              fontWeight: 600,
              width: "130px",
            }}
            disabled={isFirstStep || disabled}
            startIcon={<ChevronLeftIcon color="primary" style={{ height: "22px", marginLeft: "-8px"}} />}
            onClick={handlePrevStep}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            style={{
              paddingTop: "0.25rem",
              paddingBottom: "0.25rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              borderRadius: "0.375rem",
              height: "2.5rem",
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
              fontWeight: 600,
              width: "130px",
            }}
            disabled={disabled}
            onClick={handleNextStep}
          >
            {isLastStep ? "Salvar" : "Próximo"}
          </Button>
        </div>
      )}
    </>
  );
}